export default angular.module('gm.wealth.common', [
  'gm.common.constants',
]).name;

require('./components/recap-table-header/recap-table-header.ts');
require('./components/recap-table-row/recap-table-row.ts');
require('./controllers/base-flow/base-flow');
require('./directives/action/action');
require('./directives/box-date-picker/box-date-picker');
require('./directives/box-input/box-input');
require('./directives/box-input-simple/box-input-simple');
require('./directives/box-phone-input/box-phone-input');
require('./directives/box-selector/box-selector');
require('./directives/checkbox/checkbox');
require('./directives/date/date');
require('./directives/digits-only/digits-only');
require('./directives/expected-use/expected-use');
require('./directives/fee-tiers/fee-tiers');
require('./directives/fee-tiers-mobile/fee-tiers-mobile');
require('./directives/flag/flag');
require('./directives/focus-out-flyout-close/focus-out-flyout-close');
require('./directives/format-model-currency/format-model-currency');
require('./directives/generic-complete-header/generic-complete-header');
require('./directives/load-script/load-script');
require('./directives/main-table/main-table');
require('./directives/main-table-body/main-table-body');
require('./directives/main-table-body-col/main-table-body-col');
require('./directives/main-table-body-row/main-table-body-row');
require('./directives/main-table-header/main-table-header');
require('./directives/main-table-header-col/main-table-header-col');
require('./directives/matches/matches');
require('./directives/max/max');
require('./directives/min/min');
require('./directives/number-int/number-int');
require('./directives/order-complete-header/order-complete-header');
require('./directives/print/print');
require('./directives/radio-option/radio-option');
require('./directives/remaining-time/remaining-time');
require('./directives/sidebar-list/sidebar-list');
require('./directives/sidebar-list-link/sidebar-list-link');
require('./directives/sidebar-progress/sidebar-progress');
require('./directives/submit/submit');
require('./directives/time/time');
require('./directives/toggle-option/toggle-option');
require('./directives/toggle-option-group/toggle-option-group');
require('./directives/tooltip/tooltip');
require('./filters/add-percentage');
require('./filters/add-period');
require('./filters/is-array');
require('./filters/is-in-grams');
require('./filters/product-type.ts');
require('./filters/remove-hyphens');
require('./filters/slash-to-newline');
require('./filters/subtract-percentage');
require('./filters/translate-number.ts');
require('./filters/truncate');
require('./filters/validation-info');
require('./services/2fa');
require('./services/modal');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/common/index.js